import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '../services/user.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private _userService = inject(UserService);


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this._userService.Logout();
                if (!location.pathname.toLowerCase().startsWith("/login") 
                        && !location.pathname.toLowerCase().startsWith(`/en/login`) 
                        && !location.pathname.toLowerCase().startsWith("/clarionlogin")
                        && !location.pathname.toLowerCase().startsWith(`/en/clarionlogin`)
                        && !location.pathname.toLowerCase().startsWith(`/test/login`)
                        && !location.pathname.toLowerCase().startsWith(`/test/en/login`)) {
                    location.reload();
                }
            }
            return throwError(err);
        }));
    }
}
